import React from 'react';
import AuthStore from 'stores/AuthStore';
import 'styles/LegacyWrapper.styl';
import {GlobalComponents} from 'components/init/globalComponents';
import connectToStores from 'alt-utils/lib/connectToStores';
import {RouterLocation} from '@store/@types/util/ReactRouter';
import {ThemeProvider} from '@components/@theme';
import {PrimaryNav} from '@components/primary-nav/PrimaryNav';

interface AuthWrapperProps {
  location: RouterLocation;
}

/**
 * Handles all post-auth setup needed by the app and
 * keeps the app from rendering until token is available.
 *
 * Also hosts global components which are available throughout the entire app.
 */
@connectToStores
export default class AuthWrapper extends React.Component<
  AuthWrapperProps & ReturnType<typeof AuthWrapper.getPropsFromStores>
> {
  static getStores() {
    return [AuthStore];
  }

  static getPropsFromStores() {
    const {user} = AuthStore.getState();
    return {user};
  }

  render() {
    const {location, children, user} = this.props;
    if (!user) return null;

    return (
      <ThemeProvider>
        <PrimaryNav user={user}>{children}</PrimaryNav>
        <GlobalComponents location={location} />
      </ThemeProvider>
    );
  }
}
